import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[hasRoles]'
})
export class HasRoleDirective implements OnChanges {
  private visible: boolean = false;
  private roles: string[] = [];
  private user: any;

  @Input() set hasRoles(roles: string[]) {
    this.roles = roles;
  }

  @Input() set hasRolesFor(user: any) {
    this.user = user;
  }
  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnChanges(): void {
    this.updateView();
  }

  private updateView(): void {
    const userRoles: string[] =
      Array.isArray(this.user?.roles) && this.user.roles.length > 0
        ? this.user.roles.map((r: any) => r.name).filter(Boolean)
        : this.user?.role?.name
          ? [this.user.role.name]
          : [];

    if (userRoles.length === 0) {
      return;
    }

    if (userRoles.some((r) => this.roles.includes(r))) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.visible = true;
    } else {
      this.viewContainer.clear();
      this.visible = false;
    }
  }
}
